import axios from "@/repositories/client";

axios.getSuppliers = (query, pagination) => {

  let options = {
    params: {
      search: query,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get('athena/v1/suppliers', options)
    .then(response => {
      return response.data;
    });
};

axios.getSupplier = (id) => {
  return axios.get(`athena/v1/suppliers/${id}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveSupplier = (supplier) => {
  const url = `athena/v1/suppliers` + (supplier.id ? `/${supplier.id}` : '');
  const verb = supplier.id ? 'PUT' : 'POST';

  supplier.contact.emails = supplier.contact.emails.filter(e => (!!e.name && !!e.email));
  supplier.contact.phone_numbers = supplier.contact.phone_numbers.filter(p => (!!p.name && !!p.number));

  return axios.request({method: verb, url: url, data: supplier})
    .then(response => {
      return response.data.data;
    });
};

axios.destroySupplier = (supplier) => {
  return axios.delete(`athena/v1/suppliers/${supplier}`)
    .then(response => {
      return response.data;
    });
};

export default axios;